import React from 'react';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import LogoCard from '../LogoCard/LogoCard';
import clientIcon from '../../images/icons/client.svg';
import './LogoCardSection.css';
import prudential from '../../images/clients/prudential.png';
import netmed from '../../images/clients/netmed.png';
import neil from '../../images/clients/neil-clima.png';
import korund from '../../images/clients/korund.png';
import neoris from '../../images/clients/neoris.png';
import israel from '../../images/clients/embajada-israel.png';
import bengroup from '../../images/clients/bengroup.png';
import bestiaPeluda from '../../images/clients/bestia-peluda.png';
import logoKras from '../../images/clients/logo-kras.png';
import sanofi from '../../images/clients/sanofilogo.png';
import topcret from '../../images/clients/topcret.png';
import virtualWorld from '../../images/clients/virtualworld.png';
import waycar from '../../images/clients/waycar.png';
import { useLanguage } from '../../context/LanguageContext';

const LogoCardSection: React.FC = () => {
  const { t } = useLanguage();

  const defaultLogo = clientIcon;  // Use the imported SVG
  
  const logos = [
    { src: bengroup, alt: 'Ben Group' },
    { src: prudential, alt: 'Prudential' },
    { src: netmed, alt: 'Netmed Solutions' },
    { src: neil, alt: 'Neil Climatizadores' },
    { src: korund, alt: 'Korund' },
    { src: bestiaPeluda, alt: 'Bestia Peluda' },
    { src: neoris, alt: 'Neoris' },
    { src: israel, alt: 'Embajada de Israel' },
    { src: logoKras, alt: 'Logo Kras' },
    { src: sanofi, alt: 'Sanofi' },
    { src: topcret, alt: 'TopCret' },
    { src: virtualWorld, alt: 'Virtual World' },
    { src: waycar, alt: 'Waycar' },
  ];

  const getGroupSize = () => {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 991) return 2;
    if (window.innerWidth <= 1200) return 3;
    return 4;
  };

  const [itemsPerGroup, setItemsPerGroup] = React.useState(getGroupSize());
  const [isManualTransition, setIsManualTransition] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      setItemsPerGroup(getGroupSize());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Always fill each group with itemsPerGroup logos, duplicating from the start if needed
  const logoGroups = [];
  const total = logos.length;
  const numGroups = Math.ceil(total / itemsPerGroup);
  for (let i = 0; i < numGroups; i++) {
    const start = i * itemsPerGroup;
    let group = logos.slice(start, start + itemsPerGroup);
    if (group.length < itemsPerGroup) {
      // Duplicate from the start to fill the group
      group = group.concat(logos.slice(0, itemsPerGroup - group.length));
    }
    logoGroups.push(group);
  }

  const svgFilter = (
    <svg width="0" height="0" style={{ position: 'absolute'}}>
      <defs>
        <linearGradient id="gradient-filter" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#54D8D9" />
          <stop offset="100%" stopColor="#7767EB" />
        </linearGradient>
      </defs>
    </svg>
  );

  const nextIcon = <span className="carousel-arrow-next">&gt;</span>;
  const prevIcon = <span className="carousel-arrow-prev">&lt;</span>;

  const handleSelect = (selectedIndex: number, e: Record<string, unknown> | null) => {
    // Check if the transition was triggered by next/prev buttons
    if (e?.source === 'next' || e?.source === 'prev') {
      setIsManualTransition(true);
      // Remove manual transition class after the transition
      setTimeout(() => setIsManualTransition(false), 50);
    }
  };

  return (
    <section className="logo-section">
      {svgFilter}
      <Container>
        <Row className="justify-content-center">
          <Col xs={12}>
            <h2 className="section-title nav-font text-center mb-5">NUESTROS CLIENTES</h2>
            <Carousel 
              interval={8000}
              controls={true} 
              indicators={false}
              className={`logo-carousel ${isManualTransition ? 'manual-transition' : ''}`}
              pause="hover"
              touch={true}
              nextIcon={nextIcon}
              prevIcon={prevIcon}
              wrap={true}
              slide={true}
              onSelect={handleSelect}
            >
              {logoGroups.map((group, groupIndex) => (
                <Carousel.Item key={groupIndex}>
                  <div className="d-flex justify-content-center">
                    <div className="logo-grid">
                      {group.map((logo, index) => (
                        <LogoCard key={`${groupIndex}-${index}`} imageSrc={logo.src} alt={logo.alt} />
                      ))}
                    </div>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default LogoCardSection;
